import classNames from 'classnames'
import React from 'react'

export function Loader({ className }: { className?: string }) {
  return (
    <div className={classNames('loader-wrapper', className)}>
      <div className="loader">
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  )
}
